// src/app/turnstile/turnstile.component.ts
import {
  Component,
  AfterViewInit,
  OnDestroy,
  Output,
  EventEmitter,
  Input,
  ElementRef,
  ViewChild,
  NgZone,
} from '@angular/core';

@Component({
  selector: 'turnstile',
  template: `<div #turnstileContainer></div>`,
})
export class TurnstileComponent implements AfterViewInit, OnDestroy {
  @ViewChild('turnstileContainer', { static: true })
  container!: ElementRef<HTMLDivElement>;

  @Input() siteKey: string = '';
  @Input() theme: 'light' | 'dark' | 'auto' = 'auto';

  @Output() verified = new EventEmitter<string>();
  @Output() errored = new EventEmitter<void>();
  @Output() expired = new EventEmitter<void>();

  private widgetId: string | null = null;

  constructor(private ngZone: NgZone) {}

  ngAfterViewInit(): void {
    // Wait for the Turnstile script to be ready
    const interval = setInterval(() => {
      if (typeof turnstile !== 'undefined') {
        clearInterval(interval);
        this.renderWidget();
      }
    }, 100);
  }

  private renderWidget(): void {
    this.widgetId = turnstile.render(this.container.nativeElement, {
      sitekey: this.siteKey,
      theme: this.theme,
      callback: (token: string) => {
        this.ngZone.run(() => this.verified.emit(token));
      },
      'error-callback': () => {
        this.ngZone.run(() => this.errored.emit());
      },
      'expired-callback': () => {
        this.ngZone.run(() => this.expired.emit());
      },
    });
  }

  reset(): void {
    if (this.widgetId) {
      turnstile.reset(this.widgetId);
    }
  }

  ngOnDestroy(): void {
    if (this.widgetId) {
      turnstile.remove(this.widgetId);
    }
  }
}
